import { useContractReads } from "wagmi";
import useAccount from "@/hooks/useAccount";
import { validatorContracts } from "@/services/contract";

const Stage = {
  0: "Closed",
  1: "Pre-Sale",
  2: "Public-Sale",
} as any;

export default function useValidatorContract(chainId: number) {
  const { address } = useAccount();
  const contract = validatorContracts[chainId];

  const { data } = useContractReads({
    watch: false,
    contracts: [
      {
        ...contract,
        functionName: "currentStage",
      },
      {
        ...contract,
        functionName: "totalSupply",
      },
      {
        ...contract,
        functionName: "balanceOf",
        args: [address],
      },
      {
        ...contract,
        functionName: "privateValidatorMint",
        args: [address],
      },
      {
        ...contract,
        functionName: "mintBatch",
        args: [1],
      },
    ] as any,
  });

  const stage = Number(data?.[0]?.result || 0);

  return {
    stage,
    stageDesc: Stage[stage],
    quantity: Number((data?.[1]?.result as bigint) || 0),
    isReady: !!data,
    balance: (data?.[2]?.result as bigint) || 0n,
    privateMinted: !!data?.[3],
    totalSupply: (data?.[4]?.result as bigint) || 0n,
  };
}
